// src/pages/AdminOrders.js
import React, { useEffect, useState } from 'react';
import { useAdmin } from '../contexts/AdminContext';

const AdminOrders = () => {
  const { fetchOrders, orders } = useAdmin();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOrders = async () => {
      await fetchOrders();
      setLoading(false);
    };
    loadOrders();
  }, [fetchOrders]);

  if (loading) return <div>Loading Orders...</div>;

  return (
    <div style={{ padding: '20px', background: '#fff' }}>
      <h2>Orders</h2>
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        <ul>
          {orders.map(order => (
            <li key={order.id}>
              <strong>Order ID:</strong> {order.id} <br />
              <strong>Customer:</strong> {order.customerName || 'Unknown'} <br />
              <strong>Package:</strong> {order.package} <br />
              <strong>Status:</strong> {order.status} <br />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdminOrders;